<template>
	<div class="page-bar clearfix" v-show="value.total > value.pageSize">
		<el-pagination class="pull-right" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="value.pageNo" :page-sizes="[20, 50, 100, 200]" :page-size="value.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="value.total"></el-pagination>
	</div>
</template>

<script>
import sessionStorage from '@utils/store/sessionStorage'
export default {
	name: 'page-bar',
	props: {
		value: {
			type: Object,
			required: true // 必传
		}
	},
	created() {
		let that = this
		if (sessionStorage.has('pagelist')) {
			let list = sessionStorage.get('pagelist').filter(p => p.url === this.$route.path)

			if (list.length > 0) {
				this.value.pageNo = list[0].page.pageNo
				this.value.pageSize = list[0].page.pageSize
			}

			if (this.value.records) {
				delete this.value.records
			}
		}
	},
	methods: {
		handleSizeChange(val) {
			this.value.pageSize = val
			this.$emit('change')
		},
		handleCurrentChange(val) {
			this.value.pageNo = val

			//缓存分页信息
			let pagelist = sessionStorage.get('pagelist') || []
			let obj = pagelist.filter(p => p.url === this.$route.path)

			if (pagelist.length > 5 && obj.length > 0) {
				pagelist.shift()
			}

			if (obj.length) {
				obj[0].page.pageNo = this.value.pageNo
				obj[0].page.pageSize = this.value.pageSize
			} else {
				pagelist.push({ url: this.$route.path, page: this.value })
			}

			sessionStorage.set('pagelist', pagelist)
			this.$emit('change')
		}
	},
	data() {
		return {
			userList: [],
			multipleSelection: [],
			dialogVisible: false
		}
	}
}
</script>
